<template>
  <div>
    <template v-if="_.trim(ftieId) === ''">
      {{ ftieId }}
    </template>
    <template v-else>
      <a class="link" target="_blank" :href="safeUrl(`${ $root.frontEndUrl }/ftie/ftie-page/${ ftieId }`)">{{ ftieId }}</a>
    </template>
  </div>
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'gtc-link-to-ftie-dashboard',
    props: ['ftieId']
  }
</script>



// WEBPACK FOOTER //
// src/components/framework/GtcFtieDashboardLink.vue